export default "__VITE_ASSET__aI2klHJ2__"